module.exports = __webpack_public_path__ + "media/images/illustrations/mover_with_sixteen_foot_truck-42eca908b6ff0adbd08da946da854fdd.svg";